import React, { createContext, useReducer } from "react";
import { initialState } from "./initialState";
import { reducer } from "./reducer";
import { IQrCodeAction, IReducerResponse } from "./type";

interface IResponseContext {
    state: IReducerResponse;
    dispatch: React.Dispatch<IQrCodeAction>;
}
export const ResponseContext = createContext<IResponseContext>({
    state: initialState,
    dispatch: () => {},
});

export const ResponseContextProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <ResponseContext.Provider value={{ state, dispatch }}>{children}</ResponseContext.Provider>
    );
};
